import ReactCodeMirror from '@uiw/react-codemirror';
import useEventCallback from 'hooks/useEventCallback';
import React, { useCallback } from 'react';
import FieldRegister from 'views/common/FieldRegister';
import TextField from 'views/common/TextField';
import JsonSchemeCreator from './JsonSchemeCreator';
import { json, jsonParseLinter } from '@codemirror/lang-json';
import { linter, lintGutter } from '@codemirror/lint';
import { validateRequired } from 'utils/validate';
import { getTheme } from 'utils/editorTheme';

const InputDescription = ({
  onChange,
  stateInfo,
  isPageApprove,
  permissionDisabled,
  theme,
}) => {
  const onChangeInputTest = useCallback((e) => {
    onChange((stateInfo) => ({ ...stateInfo, inputTest: e }));
    // eslint-disable-next-line
  }, []);

  const onChangeInputDesc = useEventCallback(
    (v) => {
      onChange({ ...stateInfo, inputDesc: v });
    },
    [stateInfo]
  );

  return (
    <div className="input-project">
      <div className="input-project__block">
        <TextField
          label="Params"
          required
          help={
            <span>Param using call this function. Params must is a Object</span>
          }
        >
          <JsonSchemeCreator
            className="border-wraper-input"
            value={stateInfo.inputDesc}
            type="OBJECT"
            title="Input Params"
            onChange={onChangeInputDesc}
            disabled={isPageApprove || permissionDisabled}
          />
        </TextField>
      </div>
      <div className="input-project__block">
        <FieldRegister
          name="inputTest"
          value={stateInfo.inputTest}
          onChange={onChangeInputTest}
          validate={validateRequired('Input sample')}
          disabled={isPageApprove || permissionDisabled}
          theme={theme}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField label="Input Sample" required helperText={error}>
              <div className="border-wraper-input">
                <ReactCodeMirror
                  value={value}
                  onBlur={onBlur}
                  height="300px"
                  extensions={[json(), lintGutter(), linter(jsonParseLinter())]}
                  onChange={onChange}
                  theme={getTheme(theme)}
                  editable={!disabled}
                />
              </div>
            </TextField>
          )}
        </FieldRegister>
      </div>
    </div>
  );
};

export default InputDescription;
